import { render, staticRenderFns } from "./TicketsList.vue?vue&type=template&id=4e398145&"
import script from "./TicketsList.vue?vue&type=script&lang=js&"
export * from "./TicketsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e398145')) {
      api.createRecord('4e398145', component.options)
    } else {
      api.reload('4e398145', component.options)
    }
    module.hot.accept("./TicketsList.vue?vue&type=template&id=4e398145&", function () {
      api.rerender('4e398145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/TicketsList.vue"
export default component.exports